import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap/modal";
import { ApiRequestDto, ReportsService } from "../../api";
import { FacilitiesService } from "../../core";
import { DownloadFileContentModal } from "../download-file-content/download-file-content-modal.component";
import { LoadingError, ErrorObjectTypeEnum } from '../../core/error-catching.service';
import { catchError } from 'rxjs/operators';


@Component({
    selector: 'my-credit-detail-modal',
    styleUrls: ['../download-file-content/download-file-content-modal.component.scss'],
    templateUrl: '../download-file-content/download-file-content-modal.component.html'
})

export class CreditDetailModal extends DownloadFileContentModal {

    //@ViewChild('recordsModal', {static: false}) public recordsModal: ModalDirective;

    constructor( private reportService: ReportsService, private facilityService: FacilitiesService){
        super();
        this.maxDate = this.endDate;
    }

    reportName: string = "Credit Detail";
    title: string = "Download Credit Detail";
    showDateRangeSelector: boolean = true;

    generateContent(){
        if (this.dateRange && this.dateRange.startDate && this.dateRange.endDate) {
            //this triggers the visual cue that works is been done
            this.hideSpinner = false;
            const requestParams: ApiRequestDto = { 
                OrgList: this.facilityService.selectedAsOrgList,
                StartDate: this.dateRange.startJsDateUTC,
                EndDate: this.dateRange.endJsDateUTC,
            };
            this.reportService.reportsGetGeneratedCreditDetailReport(requestParams)
                .pipe(catchError((error) => {
                    this.hideSpinner = true;
                    throw new LoadingError(this.reportName, ErrorObjectTypeEnum.Report);
                }))
                .subscribe((result: Blob) => {
                    this.downloadFile(result, 'CreditDetail.xls');
                    this.closeModal();
                });   
        } 
    }
}